export const de_policies = {
  refund: {
    title: "Rückerstattungsrichtlinie",
    backToCheckout: "Zurück zur Kasse",
    backToHome: "Zurück zur Startseite",
    setupFeeNotice: "Die Einrichtungsgebühr von €500 ist nicht erstattungsfähig, sobald die Entwicklung begonnen hat.",
    subscriptionNotice: "Abonnementzahlungen sind für abgerechnete Zeiträume nicht erstattungsfähig.",
    exceptionalCircumstances: "Außergewöhnliche Umstände",
    exceptionalText: "Dathent behält sich Ermessensentscheidungen bei außergewöhnlichen Umständen vor.",
    processTitle: "Rückerstattungsprozess",
    processText: "Wenn Sie glauben, einen berechtigten Fall für eine Rückerstattungsausnahme zu haben, kontaktieren Sie uns bitte unter:",
    earlyTerminationTitle: "Vorzeitige Kündigung",
    earlyTerminationText: "Für Informationen zur vorzeitigen Kündigung des Infrastructure Commitment Modells lesen Sie bitte die",
    termsLink: "Nutzungsbedingungen",
    lastUpdated: "Zuletzt aktualisiert: Februar 2026"
  },
  privacy: {
    title: "Datenschutzrichtlinie",
    backToCheckout: "Zurück zur Kasse",
    backToHome: "Zurück zur Startseite",
    dataControllerTitle: "Verantwortlicher",
    companyName: "DATHENT SAX S.L.",
    nif: "NIF B22632632",
    address1: "Avenida Reyes Católicos 9, Bajo",
    address2: "03630 Sax (Alicante), Spanien",
    dataCollectedTitle: "Erfasste Daten",
    dataCollectedText: "Wir erfassen und verarbeiten folgende Kategorien personenbezogener Daten:",
    contactDetails: "Kontaktdaten (Name, E-Mail, Telefon)",
    projectInfo: "Projektinformationen",
    commHistory: "Kommunikationsverlauf",
    purposeTitle: "Zweck",
    purposeText: "Daten werden ausschließlich verarbeitet für:",
    serviceDelivery: "Leistungserbringung",
    clientComm: "Kundenkommunikation",
    paymentProcessing: "Zahlungsabwicklung",
    operationalImprovement: "Betriebliche Verbesserung",
    paymentSecurityTitle: "Zahlungssicherheit",
    paymentSecurityText1: "Zahlungen werden verarbeitet über",
    paymentSecurityText2: "Dathent speichert keine Zahlungskarteninformationen.",
    dataRightsTitle: "Datenrechte",
    dataRightsText: "Gemäß DSGVO können Kunden Folgendes anfordern:",
    accessRight: "Zugang zu ihren personenbezogenen Daten",
    rectificationRight: "Berichtigung ungenauer Daten",
    erasureRight: "Löschung personenbezogener Daten",
    restrictionRight: "Einschränkung der Verarbeitung",
    requestsLabel: "Anfragen:",
    dataRetentionTitle: "Datenspeicherung",
    dataRetentionText: "Personenbezogene Daten werden nur so lange aufbewahrt, wie es für die oben genannten Zwecke erforderlich ist oder wie es das anwendbare Recht vorschreibt.",
    thirdPartySharingTitle: "Weitergabe von Daten an Dritte",
    thirdPartySharingText: "Wir verkaufen oder teilen personenbezogene Daten nicht mit Dritten, außer soweit dies für die Leistungserbringung erforderlich ist (z.B. Zahlungsabwicklung über Stripe).",
    contactTitle: "Kontakt",
    contactText: "Bei datenschutzbezogenen Anfragen wenden Sie sich bitte an:",
    lastUpdated: "Zuletzt aktualisiert: Februar 2026"
  },
  terms: {
    title: "Nutzungsbedingungen",
    backToCheckout: "Zurück zur Kasse",
    backToHome: "Zurück zur Startseite",
    companyTitle: "1. Unternehmen",
    companyText: "Diese Website und die zugehörigen Dienste werden betrieben von:",
    companyName: "DATHENT SAX S.L.",
    cif: "CIF B22632632",
    address1: "Avenida Reyes Católicos 9, Bajo",
    address2: "03630 Sax (Alicante), Spanien",
    companyNote: "Dienstleistungen werden nach spanischem Recht erbracht und im Handelsregister von Alicante eingetragen.",
    companyDesc: "Dathent bietet strukturierte Website-Infrastruktur- und langfristige technische Support-Lösungen für Unternehmen.",
    serviceModelsTitle: "2. Servicemodelle",
    serviceModelsText: "Dathent bietet zwei kommerzielle Modelle:",
    fullDevTitle: "A. Vollständiges Entwicklungsmodell",
    fullDevPrice: "Einmalige Zahlung: €1500",
    fullDevNoSubscription: "Keine Abonnementverpflichtung.",
    fullDevDesc: "Dieses Modell umfasst die vollständige Website-Lieferung ohne langfristige Support-Verpflichtung.",
    infraCommitTitle: "B. Infrastructure Commitment Modell",
    infraSetup: "Ersteinrichtung: €500",
    infraSupport: "Laufender Infrastruktur-Support: €50 pro Monat",
    infraMinimum: "Mindestverpflichtung: 12 Monate",
    infraDesc: "Dieses Modell bietet einen reduzierten Entwicklungspreis im Austausch für eine strukturierte langfristige Support-Vereinbarung.",
    infraNote: "Die Standard-Support-Rate beträgt €150 pro Monat. Die €50-Rate ist ein vertraglicher Anreiz, der an die 12-monatige Verpflichtung gebunden ist.",
    commercialStructureTitle: "3. Kommerzielle Struktur",
    commercialPoint1: "Die reduzierte Entwicklungsgebühr (€500) ist kein eigenständiges Produkt.",
    commercialPoint2: "Sie ist Teil einer strukturierten Infrastrukturvereinbarung.",
    commercialPoint3: "Der wirtschaftliche Wert der Entwicklung beträgt weiterhin €1500.",
    commercialPoint4: "Der reduzierte Einstiegspreis wird in Anbetracht der 12-monatigen Verpflichtung gewährt.",
    earlyTerminationTitle: "4. Vorzeitige Kündigung",
    earlyTerminationText: "Wenn der Kunde die Support-Vereinbarung vor Ablauf von 12 Monaten kündigt, wird der verbleibende wirtschaftliche Wert fällig.",
    calculationTitle: "Berechnung:",
    fullDevValue: "Vollständiger Entwicklungswert: €1500",
    paidAtSetup: "Bei Einrichtung gezahlter Betrag: €500",
    outstandingBalance: "Ausstehender Betrag: €1000",
    settlementNote: "Nach Begleichung dieses Betrags endet die Support-Vereinbarung und es fallen keine weiteren monatlichen Gebühren an.",
    deliveryFrameworkTitle: "5. Lieferrahmen",
    deliveryText: "Die Entwicklung beginnt nach Zahlungsbestätigung und Erhalt der erforderlichen Materialien.",
    deliveryTime: "Typische Lieferzeit: ab 1 Woche.",
    acceleratedDelivery: "Eine beschleunigte Lieferung kann je nach Projektumfang möglich sein.",
    timelinesDepend: "Die Zeitpläne hängen von der Reaktionsfähigkeit des Kunden und der Projektkomplexität ab.",
    intellectualPropertyTitle: "6. Geistiges Eigentum",
    ipText: "Das vollständige Eigentum an der entwickelten Website wird nach Erfüllung der wirtschaftlichen Verpflichtungen übertragen unter:",
    ip12Months: "12-monatige Infrastrukturverpflichtung",
    ipOr: "ODER",
    ipFullPayment: "Vollständige Zahlung des Gesamtwerts von €1500",
    limitationTitle: "7. Haftungsbeschränkung",
    limitationText: "DATHENT SAX S.L. haftet nicht für:",
    thirdPartyInterruptions: "Unterbrechungen von Drittanbieterdiensten",
    hostingFailures: "Ausfälle des Hosting-Anbieters",
    clientDelays: "Verzögerungen durch unvollständige Kundeneingaben",
    limitationNote: "Die Haftung ist auf den Wert der gekauften Dienstleistung beschränkt.",
    governingLawTitle: "8. Anwendbares Recht",
    governingLawText: "Diese Bedingungen unterliegen dem Recht Spaniens.",
    lastUpdated: "Zuletzt aktualisiert: Februar 2026"
  },
  subscriptionPolicy: {
    title: "Abonnementvereinbarung",
    backToCheckout: "Zurück zur Kasse",
    backToHome: "Zurück zur Startseite",
    infraSupportTitle: "1. Infrastruktur-Support",
    infraSupportText: "Der Infrastruktur-Support-Service gewährleistet:",
    techStability: "Technische Stabilität",
    continuousMaintenance: "Kontinuierliche Wartung",
    minorAdjustments: "Kleinere funktionale Anpassungen",
    monitoring: "Überwachung und Leistungskontrolle",
    standardRate: "Standardtarif: €150 pro Monat.",
    discountedRateTitle: "2. Ermäßigte Verpflichtungsrate",
    discountedRateText: "Die €50/Monat-Rate wird ausschließlich im Rahmen des Infrastructure Commitment Modells gewährt.",
    minimumTerm: "Mindestlaufzeit: 12 Monate.",
    discountedRateNote: "Die ermäßigte Rate spiegelt eine langfristige Kooperationsstruktur wider.",
    billingStructureTitle: "3. Abrechnungsstruktur",
    billing30Days: "Die Abrechnung beginnt 30 Tage nach der ersten Einrichtungszahlung.",
    billingStripe: "Zahlungen werden sicher über Stripe abgewickelt.",
    earlyExitTitle: "4. Vorzeitige Ausstiegsklausel",
    earlyExitText: "Bei Kündigung vor 12 Monaten wird der verbleibende wirtschaftliche Wert von €1000 fällig.",
    earlyExitNote: "Nach Begleichung fallen keine weiteren Abonnementzahlungen an.",
    postCommitmentTitle: "5. Phase nach der Verpflichtung",
    postCommitmentText: "Nach 12 Monaten wird die Vereinbarung monatlich fortgesetzt.",
    postCommitmentNote: "Der Kunde kann jederzeit ohne Vertragsstrafe kündigen.",
    lastUpdated: "Zuletzt aktualisiert: Februar 2026"
  },
  cookies: {
    title: "Cookie-Richtlinie",
    backToCheckout: "Zurück zur Kasse",
    backToHome: "Zurück zur Startseite",
    whatAreCookiesTitle: "Was sind Cookies",
    whatAreCookiesText: "Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden, wenn Sie eine Website besuchen. Sie helfen der Website, Informationen über Ihren Besuch zu speichern.",
    essentialCookiesTitle: "Wesentliche Cookies",
    essentialCookiesText: "Diese Website verwendet wesentliche Cookies, die für den Betrieb erforderlich sind.",
    essentialCookiesNote: "Diese Cookies sind notwendig, damit die Website ordnungsgemäß funktioniert und können nicht deaktiviert werden.",
    analyticsCookiesTitle: "Analytische Cookies",
    analyticsCookiesText: "Analytische Cookies können verwendet werden, um die Leistung zu verbessern und zu verstehen, wie Besucher mit der Website interagieren.",
    analyticsCookiesNote: "Diese Cookies helfen uns, den Website-Traffic zu analysieren und die Benutzererfahrung zu optimieren.",
    managingCookiesTitle: "Cookies verwalten",
    managingCookiesText: "Benutzer können nicht wesentliche Cookies über die Browser-Einstellungen deaktivieren.",
    chromeSettings: "Chrome: Einstellungen → Datenschutz und Sicherheit → Cookies",
    firefoxSettings: "Firefox: Einstellungen → Datenschutz & Sicherheit → Cookies",
    safariSettings: "Safari: Einstellungen → Datenschutz → Cookies",
    disablingNote: "Hinweis: Das Deaktivieren wesentlicher Cookies kann die Funktionalität der Website beeinträchtigen.",
    thirdPartyCookiesTitle: "Cookies von Drittanbietern",
    thirdPartyCookiesText: "Wir können Dienste von Drittanbietern nutzen, die ihre eigenen Cookies setzen:",
    stripeLabel: "Stripe – für die Zahlungsabwicklung",
    analyticsLabel: "Analyse-Tools – für die Leistungsüberwachung",
    updatesTitle: "Aktualisierungen dieser Richtlinie",
    updatesText: "Wir können diese Cookie-Richtlinie von Zeit zu Zeit aktualisieren. Alle Änderungen werden auf dieser Seite mit einem aktualisierten Revisionsdatum veröffentlicht.",
    contactTitle: "Kontakt",
    contactText: "Bei Fragen zu unserer Verwendung von Cookies kontaktieren Sie uns bitte unter:",
    lastUpdated: "Zuletzt aktualisiert: Februar 2026"
  }
};
